import React, { useEffect } from 'react'
import { Outlet, useNavigate } from 'react-router-dom'
import { Box, CssBaseline, Toolbar, useMediaQuery, useTheme, Typography } from '@mui/material'
import { Sidebar } from './Sidebar'
import { Header } from './Header'
import { BottomNavigation } from './BottomNavigation'
import { Breadcrumbs } from '../core/Navigation/Breadcrumbs'
import { SkipNavigation } from '../core/Navigation/SkipNavigation'
import { usePageTitle } from '../../hooks/usePageTitle'
import { useTranslation } from 'react-i18next'
import { useAppSelector } from '../../hooks/redux'

export const Layout: React.FC = () => {
  const { t } = useTranslation()
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('md')) // < 768px
  const navigate = useNavigate()
  const { user } = useAppSelector((state) => state.auth)

  useEffect(() => {
    if (user && (user.role === 'technician' || user.role === 'inspector')) {
      navigate('/portal/tasks')
    }
  }, [user, navigate])

  // Automatically update page title on route changes
  usePageTitle()

  return (
    <Box sx={{ display: 'flex' }}>
      <CssBaseline />
      <SkipNavigation />
      <Header />
      <Sidebar />
      <Box
        component="main"
        id="main-content"
        tabIndex={-1}
        sx={{
          flexGrow: 1,
          pt: { xs: 2, sm: 3 },
          pb: isMobile ? 10 : 3, // Extra padding for bottom nav on mobile
          // Use logical properties: ps (padding-start) is next to sidebar, pe (padding-end) is next to screen edge
          ps: { xs: 2, sm: 2 },
          pe: { xs: 2, sm: 3 },
          width: '100%', // Take full available space (flex-grow will handle the actual size)
          minHeight: '100vh',
          display: 'flex',
          flexDirection: 'column',
          '&:focus': {
            outline: 'none',
          },
        }}
      >
        <Toolbar />
        <Breadcrumbs />
        <Outlet />
        <Box component="footer" sx={{ py: 3, mt: 'auto', textAlign: 'center', opacity: 0.6 }}>
          <Typography variant="caption">
            {t('about.footerCopyright')}
          </Typography>
        </Box>
      </Box>
      <BottomNavigation />
    </Box>
  )
}